const Form027TC = {
    stepName: {
        statement: "重要提示",
        personalData: "個人資料",
        takeOfficeSchoolInfo: "任職學校",
        teachingExperience: "教學經驗",
        learnDetails: "就學詳情",
        auxiliaryInformation: "輔助資料",
        signature: "其他輔助資料",
        declaration: "聲明",
        submitRequired: "所需文件",
        confirmation: "確認頁",
    },
    noteslable: [
        { step: "（a）" },
        { step: "（b）" },
        { step: "（c）" },
        { step: "（d）" },
        { step: "（e）" },
        { step: "（f）" },
        { step: "（g）" },
        { step: "（h）" },
    ],
    notesList: {
        noteA: "在填寫申請書之前，請先詳閱教育局網頁的資料 <a href='https://www.edb.gov.hk/scholarship_teacher' target='_blank'>（https://www.edb.gov.hk/scholarship_teacher）</a>及相關通函（教育局通函第 {{edbcmNo}}號）。",
        noteB: "在申請過程中，申請人須上載下列文件副本。填寫申請書之前，請準備有關文件檔案。請妥善保存文件正本以在日後作核實用途。",
        noteBlist: [
            { text: "在校外所作的貢獻" },
            { text: "對學校所作的貢獻並附有校長簽署" },
            {
                text: "個人陳述［題目 （i）、（ii）及 （iii）— 附有校長簽署的行動計劃］",
            },
            { text: "申請人的香港身份證" },
            { text: "申請人的教師註冊證" },
            { text: "碩士學位課程的院校取錄通知書" },
        ],
        noteC: "推薦書必須由申請人現職學校的校長填寫。校長須於截止日期或之前將填妥的推薦書郵寄或遞交至教育局。",
        noteD: "申請人須填妥申請書各部份，並提供正確資料。",
        noteE: "申請人須填報申請書內要求的所有個人資料（但註明可選擇是否填報的資料則屬例外）。申請人如未能提供所需的所有資料，申請將不獲受理。申請人如未獲頒發獎學金，其個人資料一般會在結果公佈後12個月銷毀。如有虛報或隱瞞事實，申請資格將被取消。",
        noteF: "申請日期由{{applyStart}}至{{applyEnd}}。請將申請書及連同相關的證明文件於截止日期前透過電子方式遞交。逾期申請將不獲受理。",
        noteG: "當完成申請程序後，申請人會獲發網上申請編號，日後可引用此編號向本組查詢。",
        noteH: "如有查詢，請電郵至{{email}}或與教育局專業發展及培訓分部{{contactPerson}}（電話：{{telphone}}）聯絡。",
    },
    label1: {
        header: {
            headerOne: "I. 聲明",
        },
        declarList: {
            tips1: "本人聲明在本申請表內所填報的所有資料均屬正確和真實。本人明白倘若故意在填寫本申請書時虛報資料或隱瞞重要事實，或未有在申請書內所提供資料已作更改後通知相關部門，可令本人喪失獲「教師獎學金（進修碩士學位課程）」（{{pursuedDate}}）的資格。倘若本人已獲發「教師獎學金」，亦可被要求歸還已獲發之獎學金。本人明白本人必須連同相關證明文件提交申請，否則本人的申請將不獲處理。",
            tips2: "此外，本人聲明：",
            tips3: "就第5步（II）中提及之課程，本人現時並沒有、將來亦不會領取由香港特區政府發出之獎學金；",
            tips4: "本人過去未曾獲頒「教師獎學金（進修碩士學位課程）」；及",
            tips5: "本人未曾接獲教育局及／或學校發出的譴責信、警告信或勸喻信，以及未曾在香港或其他地方被裁定干犯刑事罪行。",
            tips6: "本人同意香港特區政府為辦理本人的「教師獎學金」申請及核實提交的資料而進行任何所需的查詢。",
        },
        statement: "本人已閱讀、明白及同意上述條款及細則",
        termWords: "本人已閱讀及同意遵守上述條款及細則。",
    },
    label: {
        header: {
            headerOne: "I.個人資料",
        },
        whetherInfo: {
            yes: "是",
            no: "否",
        },
        sex: {
            M: "男",
            F: "女",
        },
        englishName: "英文姓名（姓氏）",
        englishNameTwo: "英文姓名（名字）",
        surname: "姓氏",
        OtherNames: "名字",
        chineseName: "中文姓名（如適用）",
        dateOfBirth: "出生日期",
        gender: "性別",
        whether: "你是否香港特別行政區永久性居民？",
        IDNumber: "香港身份證號碼",
        teacherNumber: "教員註冊號碼",
        address: "通訊地址 ",
        phone: "日間聯絡電話號碼",
        homeTelephone: "住所電話號碼",
        email: "電郵地址",
        tips: "（可選填）",
    },
    label2: {
        header: {
            headerOne: "I.任職學校",
        },
        schoolNameOfEn: "學校英文名稱",
        schoolNameOfSc: "學校中文名稱",
        schoolFaxNo: "學校傳真號碼",
        schoolTel: "學校電話號碼",
        schoolAddress: "學校地址",
        principalName: "校長姓名",
        rankPostTitle:
            "申請人的職級（如：學位教師）和職位（如：升學就業輔導主任）",
        rank: "職級",
        post: "職位",
    },
    label3: {
        header: {
            headerOne: "I.教學經驗資料 (按日期順序列出)",
        },
        schoolName: "學校名稱",
        startDate: "開始日期（月／年）",
        endDate: "結束日期（月／年)",
        rankAndPost: "職級（如：學位教師）和職位（如：升學就業輔導主任）",
        job: "職務",
    },
    label4: {
        SpecialisationInfo: {
            specialEducationalNeeds: "特殊教育需要",
            giftedEducation: "資優教育",
            inclusiveEducation: "融合教育",
            chineseCulture: "中國文化",
            chineseHistoryAndHistory: "中國歷史及世界歷史",
            educationalLeadership: "教育領導",
            careerGuidance: "升學教育輔導",
            counselling: "心理輔導",
            lifeEducation: "生命教育",
            informationTechnologyInEducation: "資訊科技教育",
            chineseLanguageEducation: "中國語文",
            englishLanguageEducation: "英國語文",
            parentEducationAndHomeSchoolCoOperation: "家長教育及家校合作",
            STEMEducation: "STEM教育",
            valuesEducation: "價值教育",
        },
        header: {
            headerOne: "I.曾經就讀的課程",
            headerTwe:
                "II.將於 {{declarDate}} 學年就讀的課程（申請人必須將於 {{declarDate}} 學年開始第一年修讀相關課程，才符合申請「獎學金」的資格。）",
        },
        nameOfInstitution: "院校名稱",
        programmeTitle: "課程名稱",
        specialisation: "範疇",
        startDate: "開始日期（月／年）",
        endDate: "結束日期（月／年）",
        qualification: "課程名稱和所獲得的資格",
        job: "職務",
        awardApplyDate: "開始日期（月／年）",
    },
    label5: {
        header: {
            headerOne: "（I）對學校所作的貢獻",
            headerTwe: "（II）在校外所作的貢獻",
        },
        schoolYear: "學年",
        nameOfItems: "項目名稱",
        Details: "詳情",
        remark: "提供過去三年你對學校所作的貢獻（每年最多三個項目)",
    },
    label6: {
        header: {
            headerOne: "（II）上傳對學校所作的貢獻並附有校長簽署",
            headerTwe:
                "（III）上傳個人陳述［題目 （i）、（ii）及 （iii）—附有校長簽署的行動計劃］",
            // headerThree: "上傳填妥的推薦書並連同校長簽署及學校蓋章",
            headerFour: "上傳申請人的香港身份證",
            headerFive: "上傳申請人的教師註冊證",
            headerSix: "上傳碩士學位課程的院校取錄通知書",
            headerSeven: "（I）上傳在校外所作的貢獻",
        },
        remark: {
            title: "備註：",
            content: "每個文件的最大大小為5MB",
            content2: "可接受的文件類型：pdf、jpg、png  ",
            content3: "最大文件數：5",
        },
        proofDocText: "可接受的文件類型：.pdf, .png , .jpg",
        tips2: "倘若申請人沒有在截止日期或之前獲得取錄通知書，申請人可於截止日期後兩星期內把取錄通知書副本電郵（ltq@edb.gov.hk）、郵寄或親身送交到教育局語文教師資歷小組。",
        tips3: "如下表另紙提供過去三年你在校外就學校教育範疇所作的貢獻（每年最多一個項目），並在此處上傳。",
        tabHeader: {
            schYear: "學年",
            itemName: "項目名稱",
            itemDetails: "詳情",
        },
        tips4: "(評審乃根據申請人所作的貢獻，以及其在各個項目中所擔任的角色而定。)",
        tips5: "如下表另紙提供過去三年你對學校所作的貢獻（每年最多三個項目），並在此處上傳。此部分須交由現職學校的校長參閱及簽署確認。",
        tips6: "就以下題目作個人陳述（中文或英文均可）。每項題目以新頁書寫，並在此處上傳。",
        tips7: {
            text1: "說明選擇修讀該專業範疇碩士學位課程的原因；（上限 300 字）",
            text2: "說明你具備優秀老師的哪些特質，並以例子加以闡釋；（上限 400 字）及",
            text3: "建議一項行動計劃#，以優化你現職學校的學與教效能，並闡述修讀這項碩士學位課程如何配合所述計劃的推行。（上限 500 字）",
        },
        tips7Step: [{ step: "（i）" }, { step: "（ii）" }, { step: "（iii）" }],
        tips8: "#行動計劃須交現職學校的校長參閱及簽署確認。",
        tips9: "(超出字數以外的內容不會獲評審。標點符號不作字數計算。)",
    },
    label9: {
        tips1: "把以下所需文件郵寄或送交到教育局語文教師資歷小組（辦公室地址：香港灣仔皇后大道東213號胡忠大廈11樓1107室）",
        tips2: "填妥的推薦書並連同校長簽署及學校蓋章",
        // tips2List: [
        //     { text: "辦公室地址：" },
        //     { text: "香港灣仔" },
        //     { text: "皇后大道東213號" },
        //     { text: "胡忠大廈11樓1107室" },
        //     { text: "教育局語文教師資歷小組" },
        // ],
        tips3: "推薦書已經上載於教育局網頁<a href='https://www.edb.gov.hk/scholarship_teacher' target='_blank'>（https://www.edb.gov.hk/scholarship_teacher）</a>。",
        tips4: "信封面請註明「申請教師獎學金（進修碩士學位課程）」。",
        tips5: "（*有關文件須由校長交回）",
        statement: "本人會安排在截止日期前把推薦書填妥及送交教育局。",
    },

    errorMsg: {
        enName: "請輸入正確的英文名稱",
        scName: "請輸入正確的中文名稱",
        email: "請輸入正確的電郵地址",

        tel: {
            digit: "需要是8-15位",
            rule: "需要匹配電話號碼規則",
            faxRule: "需要匹配傳真號碼規則",
        },
        date: {
            rule: "請輸入有效日期",
            todayOrBefore: "請選擇今天或之前",
            afterThisDate: "請在之後選擇日期{{targetDate}}",
            age: "申請人在提交時至少年滿18歲。",
            afterBirth: "該字段需要在出生日期之後",
        },
        tips: "請輸入正確格式的內容 ",
        upload: "至少上傳一個文件！",
        uploadMax: "最多上傳一個文件！",
        uploadMax5: "最多上傳五個文件！",
    },
};
export default Form027TC;
